import React from 'react';
import styles from './ErrorMessage.module.css';

const ErrorMessage = ({error}) =>
 <div className={styles.errorMessage}>{error}</div>

export default ErrorMessage;
